import {pipe, any, values} from 'ramda';
import {isNotUndefined} from 'ramda-adjunct';

export const hasObjectNonEmptyValue = pipe<[object], any[], boolean>(values, any(isNotUndefined));
